export default __webpack_public_path__ + "static/media/Logo.9f2a0fa1.png";